export default __webpack_public_path__ + "static/media/3_step.a32380e8.svg";